import React, { useState, useEffect } from 'react';

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    { className: 'slide-1', desktop: 'splash3.webp', mobile: 'splash3m.jpg' },
    { className: 'slide-2', desktop: 'splash2.png', mobile: 'splash2m.png' },
    { className: 'slide-3', desktop: 'splash1.webp', mobile: 'splash1m.webp' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section className="hero-carousel-container">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`carousel-slide ${slide.className} ${index === currentSlide ? 'active' : ''}`}
        ></div>
      ))}
      <div className="hero-content-overlay">
        <h1>Puchong Jaya Perodua Centre</h1>
        <p>Fast Delivery. Fast Loan Approval. Probably the best service in town.</p>
        <div>
          <a href="#models" className="cta-btn" style={{marginRight: '10px'}}>View Models</a>
          <a href="#advisors" className="cta-btn whatsapp">Find a Sales Advisor</a>
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;
